import React, { FC, useEffect } from 'react';

import Layout from '../Layout';

export const RiskPage: FC = () => {

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'scriptID'
    script.innerHTML = `
      window.__lc = window.__lc || {};
      window.__lc.license = 6869171;
      (function () {
        var lc = document.createElement('script');
        lc.type = 'text/javascript';
        lc.async = true;
        lc.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'cdn.livechatinc.com/tracking.js';
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(lc, s);
      })();
    `;
    document.body.appendChild(script);

    const chat = document.createElement('div');
    chat.className = 'new_chat';
    chat.id = 'chatID'
    chat.innerHTML = `
      <img id="liveagent_button_online_5734I000000blLR"
         style="display: none; border: 0px none; cursor: pointer"
         onclick="liveagent.startChat('5734I000000blLR')"
         src="/wp-content/themes/zota/img/online.png"/>
      <img
      id="liveagent_button_offline_5734I000000blLR" style="display: none; border: 0px none; "
      src="/wp-content/themes/zota/img/offline.png"/>
    `;
    document.body.appendChild(chat);

    // const secondScript = document.createElement('script');
    // secondScript.type = 'text/javascript';
    // secondScript.innerHTML = `
    //     if (!window._laq) {
    //     window._laq = [];
    //   }
    //   window._laq.push(function () {
    //     liveagent.showWhenOnline('5734I000000blLR', document.getElementById('liveagent_button_online_5734I000000blLR'));
    //     liveagent.showWhenOffline('5734I000000blLR', document.getElementById('liveagent_button_offline_5734I000000blLR'));
    //   });
    // `;
    // document.body.appendChild(secondScript);
    //
    // const thirdScript = document.createElement('script');
    // thirdScript.type = 'text/javascript';
    // thirdScript.src = 'https://c.la1-c1cs-lo3.salesforceliveagent.com/content/g/js/48.0/deployment.js';
    // document.body.appendChild(thirdScript);

    // const fourthScript = document.createElement('script');
    // fourthScript.type = 'text/javascript';
    // fourthScript.innerHTML = `liveagent.init('https://d.la1-c1cs-lo3.salesforceliveagent.com/chat', '5724I000000blKv', '00D260000001ON8');`;
    // document.body.appendChild(fourthScript);

    return () => {
      document.body.removeChild(script)
      document.body.removeChild(chat)
      document.getElementById('scriptID')?.remove()
      document.getElementById('chatID')?.remove()
      // document.body.removeChild(secondScript)
      // document.body.removeChild(thirdScript)
      // document.body.removeChild(fourthScript)
    }

  }, []);

  return (
    <Layout>
      <div className="risk-page-container">
        <img src='/assets/images/risk-icon.png' alt='icon'/>
        <div className='main-title'>
          <p>We're sorry, our risk parameters will not allow us to proceed with your onboarding process at this
            time.</p>
          <p>As such, we are unable to provide you with a relevant price proposal according to the combination you
            selected.</p>
        </div>
      </div>
    </Layout>
  );
};
